<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10IYylY/tc-custom/9781685503239.jpg?1723405902706" alt="This image is the cover for the book Eight Months Without You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eight Months Without You
      </h1>
      <p class="bookDescription body article font2">
        <p>Can Sami and Joakim’s relationship survive accusations of cheating, a thrown wineglass, and eight months of silence?<br/><br/>Hurtful words and a thrown wineglass in a fit of jealousy tear Sami and Joakim apart; fiery tempers and stubbornness keep them from making up. But then, after eight months without a single word, just as Sami is about to make the first move, Joakim shows up, eager to make things right.<br/><br/>Can they overcome accusations of cheating and eight months of silence? Are conversations, confessions, and planning for the future enough? Will the love they still share conquer all?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nell Iris
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?698f0b3e